// extracted by mini-css-extract-plugin
module.exports = {"banner":"ApiBanner_banner__KDvQb","title":"ApiBanner_title__LbxgB","features":"ApiBanner_features__I3da7","animation":"ApiBanner_animation__7X4z0"};